import { render, staticRenderFns } from "./ContentAndImage.vue?vue&type=template&id=0274f943"
import script from "./ContentAndImage.vue?vue&type=script&lang=js"
export * from "./ContentAndImage.vue?vue&type=script&lang=js"
import style0 from "./ContentAndImage.vue?vue&type=style&index=0&id=0274f943&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports